import { Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { JurisdictionTranslatePrefix } from "../jurisdiction.model";

import { JurisdictionPrefixService } from "./jurisdiction-prefix.service";

@Pipe({
	name: "jurisdictionTranslate",
})
export class JurisdictionTranslatePipe implements PipeTransform {
	constructor(
		private service: JurisdictionPrefixService,
		private translateService: TranslateService
	) {}

	transform(value: string): Observable<string> {
		return this.service.getJurisdictionPrefix$().pipe(
			map((jurisdiction) => {
				const key = jurisdiction === JurisdictionTranslatePrefix.Mga ? value : `${jurisdiction}.${value}`;
				const translation = this.translateService.instant(key);
				return translation === key ? key : translation;
			})
		);
	}
}
